import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import store from '@/store';

let ChannelIO = {};

ChannelIO.install = function (Vue, options) {
  if (options.type === 'superchart') {
    const user = store.getters.user;
    console.log('@ChannelIO', store.getters);

    ChannelService.loadScript();

    let settings = { pluginKey: 'd5e84162-5a44-4aea-850a-0b14d0fb7b0e' };

    if (user != null) {
      settings = {
        ...settings,
        memberId: user.id,
        profile: {
          name: user.name,
          mobileNumber: user.phoneNumber,
          email: user.email,
        },
      };
    }

    ChannelService.boot(settings);

    Vue.prototype.$channel = ChannelService;
  }
};

export default ChannelIO;
